import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spareparts-warning"
}
const _hoisted_2 = { class: "spareparts-warning-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_sparepart_view = _resolveComponent("sparepart-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hasEquipmentSpecificSpareparts && !_ctx.warningDismissed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_my_icon, {
            icon: "warning",
            size: 28,
            color: "#e6a800",
            class: "spareparts-warning-icon"
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.localize('EquipmentWarningGeneralSpareparts')), 1),
          _createVNode(_component_my_icon, {
            icon: "x",
            size: 18,
            color: "#7a5800",
            class: "spareparts-warning-close",
            title: _ctx.localize('close'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.warningDismissed = true))
          }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_sparepart_view, {
      "equipment-mode": _ctx.hasEquipmentSpecificSpareparts,
      "model-filter": _ctx.modelFilter
    }, null, 8, ["equipment-mode", "model-filter"])
  ], 64))
}